'use client'

import { useEffect } from 'react'
import { initBrowserErrorReporter } from '@/lib/browser-error-reporter'

export function BrowserErrorInit() {
  useEffect(() => {
    const cleanup = initBrowserErrorReporter()
    return cleanup
  }, [])
  return null
}
